import { Component, OnInit } from '@angular/core';
import { Reservation } from "../../../classes/reservation";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-reservation-create-modal',
  templateUrl: './reservation-create-modal.component.html',
  styleUrls: ['./reservation-create-modal.component.css']
})
export class ReservationCreateModalComponent implements OnInit {
  date = new Date();

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

}
